var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 12.041 15.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-lock",
    "data-name": "Icon ionic-ios-lock",
    d: "M17.285,8.793h-.9V7.036a3.612,3.612,0,1,0-7.224-.049V8.793h-.9A1.509,1.509,0,0,0,6.75,10.3v7.224a1.509,1.509,0,0,0,1.505,1.505h9.03a1.509,1.509,0,0,0,1.505-1.505V10.3A1.509,1.509,0,0,0,17.285,8.793Zm-3.988,4.7v2.589a.54.54,0,0,1-.5.542.527.527,0,0,1-.553-.527v-2.6a1.2,1.2,0,1,1,1.054,0Zm2.032-4.7H10.212V6.987a2.559,2.559,0,0,1,5.117,0Z",
    transform: "translate(-6.75 -3.374)",
    fill: "#c3cad8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.097b10d91a5372b98b0d8dd67e71a848.svg";
export { ForwardRef as ReactComponent };